import useBacktestStore from '../Store/backtestStore';

function formatNum(v, opts = {}) {
  if (v === null || v === undefined) return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString(undefined, opts);
}

function formatMoney(v) {
  if (v === null || v === undefined) return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

function formatPct(v) {
  if (v === null || v === undefined) return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return `${n.toFixed(2)}%`;
}

function formatDec(v, digits = 2) {
  if (v === null || v === undefined) return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toFixed(digits);
}

export default function BacktestKpis() {
  const { status, error, stats, lastUpdated } = useBacktestStore();

  if (status === 'connecting' || status === 'loading') {
    return <div className="mutedLine">Loading backtest data…</div>;
  }

  if (status === 'error') {
    return (
      <div className="alert">
        <div className="alertTitle">Failed to load</div>
        <div className="alertBody">{error}</div>
      </div>
    );
  }

  if (!stats) {
    return <div className="mutedLine">No stats loaded.</div>;
  }

  return (
    <div className="kpiGrid">
      {/* Core headline */}
      <Kpi label="Starting Capital" value={formatMoney(stats.starting_portfolio)} />
      <Kpi label="Ending Capital" value={formatMoney(stats.ending_portfolio)} />
      <Kpi label="Total PnL" value={formatMoney(stats.total_pnl_dollars)} />
      <Kpi label="Total Trades" value={formatNum(stats.total_trades)} />

      {/* Quality metrics */}
      <Kpi label="Win Rate" value={formatPct(stats.win_pct)} />
      <Kpi label="Expectancy / Trade" value={formatMoney(stats.expectancy_per_trade_dollars)} />
      <Kpi label="Max Drawdown" value={formatMoney(stats.max_drawdown_dollars)} />
      <Kpi label="Max Drawdown %" value={formatPct(stats.max_drawdown_pct)} />

      {/* Ratios */}
      <Kpi label="Sharpe (Ann.)" value={formatDec(stats.sharpe_daily_annualized, 2)} />
      <Kpi label="Calmar" value={formatDec(stats.calmar, 2)} />
      <Kpi label="Profit Factor" value={formatDec(stats.pcr_profit_factor, 2)} />
      <Kpi label="CAR" value={formatPct(stats.car)} />

      <div className="kpiFooter">
        Last updated: {lastUpdated ? new Date(lastUpdated).toLocaleString() : '—'}
      </div>
    </div>
  );
}

function Kpi({ label, value }) {
  return (
    <div className="kpiCard">
      <div className="kpiLabel">{label}</div>
      <div className="kpiValue">{value}</div>
    </div>
  );
}

